<div mat-dialog-title class="d-flex align-items-center" data-testid="customer-training-dialog">
  <h2 class="headline text-white">Help Materials: Login</h2>
</div>
<div mat-dialog-content>
  @if (files.length > 0) {
    <table matSort mat-table [dataSource]="files" class="w-100 my-2">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef style="padding-left: 100px">Title</th>
        <td
          mat-cell
          mat-header-cell
          *matCellDef="let item"
          style="text-transform: capitalize"
          data-testid="training-material-document"
        >
          <img src="../../../../../assets/svg/pdf.svg" alt="pdf-file-icon" height="55px" style="margin-right: 25px" />
          {{ formatName(item.name) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell mat-header-cell *matCellDef="let item">{{ formatDate(item.lastModified) }}</td>
      </ng-container>
      <ng-container matColumnDef="url">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" style="text-align: right; justify-content: flex-end">
          <a [href]="item.url" target="_blank"> Open </a>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  }
  @if (files.length === 0) {
    <div class="dialog-empty-state">
      <img src="../../../../../assets/svg/empty-state_no-pdfs.svg" alt="No videos available" />
      <p>Something went wrong, please contact support</p>
    </div>
  }
</div>
<div mat-dialog-actions class="d-flex align-items-center justify-content-end mt-2">
  <button mat-flat-button color="primary" (click)="close()">Close</button>
</div>
